module.exports = __webpack_public_path__ + "img/profile.002c8fcd.png";